export const SliderSymbol = Symbol("GsapSlider");
